import { render, staticRenderFns } from "./AreaSet.vue?vue&type=template&id=94ccc854"
import script from "./AreaSet.vue?vue&type=script&lang=js"
export * from "./AreaSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports